import React, { useState, useEffect } from 'react';
import { showError } from '../utils/toast';

const PgLogs = () => {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filtro, setFiltro] = useState('todos'); // todos, hoje, ontem

    useEffect(() => {
        carregarLogs();
    }, []);

    const carregarLogs = async () => {
        try {
            setIsLoading(true);
            const response = await fetch('https://api.faeworks.com.br/log/read.php?limit=200');
            const data = await response.json();
            setLogs(data || []);
        } catch (error) {
            console.error('Erro ao carregar logs:', error);
            showError('Erro ao carregar logs');
        } finally {
            setIsLoading(false);
        }
    };

    const getLogsFiltrados = () => {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        
        const ontem = new Date(hoje);
        ontem.setDate(ontem.getDate() - 1);

        if (filtro === 'hoje') {
            return logs.filter(log => {
                const dataLog = new Date(log.timestamp);
                return dataLog >= hoje;
            });
        } else if (filtro === 'ontem') {
            return logs.filter(log => {
                const dataLog = new Date(log.timestamp);
                return dataLog >= ontem && dataLog < hoje;
            });
        }
        
        return logs;
    };

    const formatarData = (timestamp) => {
        const data = new Date(timestamp);
        return data.toLocaleString('pt-BR');
    };

    const getExtraInfo = (extraInfoJson) => {
        try {
            return JSON.parse(extraInfoJson);
        } catch {
            return {};
        }
    };

    if (isLoading) {
        return (
            <div className="container mt-5 text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        );
    }

    const logsFiltrados = getLogsFiltrados();

    return (
        <div className="container-fluid mt-4">
            <div className="row mb-4">
                <div className="col-12">
                    <h2>Logs de Erro do Portal</h2>
                    <p className="text-muted">Visualize erros capturados no portal do cliente</p>
                </div>
            </div>

            {/* Filtros e Refresh */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <div className="btn-group" role="group">
                        <button
                            type="button"
                            className={`btn ${filtro === 'todos' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setFiltro('todos')}
                        >
                            Todos ({logs.length})
                        </button>
                        <button
                            type="button"
                            className={`btn ${filtro === 'hoje' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setFiltro('hoje')}
                        >
                            Hoje
                        </button>
                        <button
                            type="button"
                            className={`btn ${filtro === 'ontem' ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setFiltro('ontem')}
                        >
                            Ontem
                        </button>
                    </div>
                </div>
                <div className="col-md-6 text-end">
                    <button
                        className="btn btn-success"
                        onClick={carregarLogs}
                    >
                        🔄 Atualizar
                    </button>
                </div>
            </div>

            {/* Lista de Logs */}
            <div className="row">
                <div className="col-12">
                    {logsFiltrados.length === 0 ? (
                        <div className="card">
                            <div className="card-body text-center py-5">
                                <p className="text-muted">Nenhum log encontrado para este filtro.</p>
                            </div>
                        </div>
                    ) : (
                        <div className="accordion" id="logsAccordion">
                            {logsFiltrados.map((log, index) => {
                                const extraInfo = getExtraInfo(log.extra_info);
                                const isInfo = extraInfo.type === 'info';
                                
                                return (
                                    <div className="accordion-item" key={log.id}>
                                        <h2 className="accordion-header">
                                            <button
                                                className={`accordion-button collapsed ${isInfo ? 'bg-light' : 'bg-danger bg-opacity-10'}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${log.id}`}
                                            >
                                                <div className="w-100">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className={`badge ${isInfo ? 'bg-info' : 'bg-danger'} me-2`}>
                                                            {isInfo ? 'INFO' : 'ERROR'}
                                                        </span>
                                                        <strong className="flex-grow-1">
                                                            {log.error_message.substring(0, 100)}
                                                            {log.error_message.length > 100 && '...'}
                                                        </strong>
                                                        <small className="text-muted ms-3">
                                                            {formatarData(log.timestamp)}
                                                        </small>
                                                        {log.user_id && (
                                                            <span className="badge bg-secondary ms-2">
                                                                User ID: {log.user_id}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </button>
                                        </h2>
                                        <div
                                            id={`collapse${log.id}`}
                                            className="accordion-collapse collapse"
                                            data-bs-parent="#logsAccordion"
                                        >
                                            <div className="accordion-body">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <h6>Mensagem:</h6>
                                                        <p className="text-break">{log.error_message}</p>
                                                        
                                                        <h6>URL:</h6>
                                                        <p className="text-break small">{log.url}</p>
                                                        
                                                        <h6>User Agent:</h6>
                                                        <p className="text-break small">{log.user_agent}</p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        {log.error_stack && (
                                                            <>
                                                                <h6>Stack Trace:</h6>
                                                                <pre className="bg-light p-2 small" style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                    {log.error_stack}
                                                                </pre>
                                                            </>
                                                        )}
                                                        
                                                        {log.extra_info && (
                                                            <>
                                                                <h6>Informações Adicionais:</h6>
                                                                <pre className="bg-light p-2 small" style={{ maxHeight: '200px', overflow: 'auto' }}>
                                                                    {JSON.stringify(extraInfo, null, 2)}
                                                                </pre>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PgLogs;
